import { Component, OnInit, ViewChild, ComponentFactoryResolver, ViewEncapsulation, ComponentRef, Input, Type } from '@angular/core';
import { AssetTrackingTabsDirective } from './tabs-host.directive';
import { TabsContainerInterface } from './tabs-container.types';

@Component({
  selector: 'tabs-container',
  template: `<ng-template asset-tracking-tabs-host></ng-template>`,
  encapsulation: ViewEncapsulation.None
})
export class TabsContainerComponent implements OnInit {
  @Input() component: Type<any>;
  @Input() data: any;
  private _componentRef: ComponentRef<any>;
  @ViewChild(AssetTrackingTabsDirective, {static: true}) tabsDirective: AssetTrackingTabsDirective;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
    this.loadComponent(this.component);
  }

  loadComponent(customTabsItem: Type<any>) {

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(customTabsItem);

    let viewContainerRef = this.tabsDirective.viewContainerRef;
    viewContainerRef.clear();

    this._componentRef = viewContainerRef.createComponent(componentFactory);
    (<TabsContainerInterface>this._componentRef.instance).data = this.data;
  }

  destroyComponent(): void {
    this._componentRef.destroy();
  }
}
